// extracted by mini-css-extract-plugin
module.exports = {"lottiePlay":"passwordRecoveredPage_lottiePlay__fHys2"};